import { ButtonHTMLAttributes, DetailedHTMLProps, useCallback, useRef } from 'react'
import { readFile, SelectedFile, asDataURL } from '../utils/File'

interface SelectFileProps {
    selectedFile: (file: SelectedFile) => void
}
function SelectFile({
    selectedFile,
    children = 'Wähle ein Bild von Dir!',
    ...rest
}: SelectFileProps & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
    const input = useRef<HTMLInputElement>(null)

    const fileHandler = useCallback(
        (e) =>
            readFile(e)
                .then(asDataURL)
                .then(selectedFile)
                .catch(() => {}),
        [selectedFile],
    )
    return (
        <>
            <button
                className="col-100 emphasize"
                {...rest}
                type="button"
                onClick={() => {
                    if (!input.current) {
                        return
                    }
                    input.current.value = ''
                    input.current.click()
                }}
            >
                {children}
            </button>
            <input
                ref={input}
                type="file"
                accept="image/*"
                style={{ visibility: 'hidden', width: '0', height: '0' }}
                onChange={fileHandler}
            />
        </>
    )
}

export default SelectFile
